import * as Storage from "ts-storage";
import jwt from "jsonwebtoken";
import { asdeweraasd } from "./../pages/PageAPI";
import axios from "axios";
import { getUserById } from "../components/User/UserAPI";

export function saveToken(token: string) {
  Storage.set("token", token);
}
export function setAuthorization(token: string) {
  if (token) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common["Authorization"];
  }
}

export async function getDataFromToken(token: string) {
  try {
    const { userId } = decodeToken(token);
    const data = await getUserById(userId);

    return data;
  } catch (err) {
    console.log(err);
    return null;
  }
}

export function decodeToken(token: string) {
  const payload: any = jwt.verify(token, asdeweraasd);

  if (payload) {
    saveToken(token);
  }

  return {
    userId: payload.id,
  };
}

export function deleteToken() {
  Storage.remove("token");
  delete axios.defaults.headers.common["Authorization"];
}
